import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { HomeProjectSection } from '../common/HomeProjectSection.js';

let MatchingProjectsSection = function (props) {
    const searchURL = props.baseSearchURL + '?max=25&hasPhoto=true';

    let url, title, className, description;
    if (!props.alternateHomeSection) {
        url = searchURL + '&matchingId=-1';
        title = 'Match offers';
        className = 'projects-match-offers';
        description = 'YOUR DONATION TO THESE PROJECTS WILL BE MATCHED BY OUR GENEROUS PARTNERS';
    } else if (props.alternateHomeSection === 'math') {
        url = searchURL + '&subject4=-4';
        title = 'STEM';
        className = 'projects-stem';
        description = '';
    } else if (props.alternateHomeSection === 'basics') {
        url = searchURL + '&proposalType=10';
        title = 'Classroom basics';
        className = 'projects-classroom-basics';
        description = '';
    }

    return (
        <HomeProjectSection searchURL={url} title={title}
            projects={props.getProjects(url)} loadProjects={props.loadProjects}
            className={className} alternateHomeSection={props.alternateHomeSection}
            description={description} />
    );
};

MatchingProjectsSection.propTypes = {
    baseSearchURL: PropTypes.string.isRequired,
    loadProjects: PropTypes.func.isRequired,
    getProjects: PropTypes.func.isRequired,

    // Temp A/B test
    alternateHomeSection: PropTypes.string,
};
MatchingProjectsSection = React.memo(MatchingProjectsSection);
export default MatchingProjectsSection;
